export default [
  {
    name: 'Alabama',
    iso2Code: 'AL',
  },
  {
    name: 'Alaska',
    iso2Code: 'AK',
  },
  {
    name: 'American Samoa',
    iso2Code: 'AS',
  },
  {
    name: 'Arizona',
    iso2Code: 'AZ',
  },
  {
    name: 'Arkansas',
    iso2Code: 'AR',
  },
  {
    name: 'Armed Forces Americas',
    iso2Code: 'AA',
  },
  {
    name: 'Armed Forces Europe',
    iso2Code: 'AE',
  },
  {
    name: 'Armed Forces Pacific',
    iso2Code: 'AP',
  },
  {
    name: 'California',
    iso2Code: 'CA',
  },
  {
    name: 'Colorado',
    iso2Code: 'CO',
  },
  {
    name: 'Connecticut',
    iso2Code: 'CT',
  },
  {
    name: 'Delaware',
    iso2Code: 'DE',
  },
  {
    name: 'District of Columbia',
    iso2Code: 'DC',
  },
  {
    name: 'Florida',
    iso2Code: 'FL',
  },
  {
    name: 'Georgia',
    iso2Code: 'GA',
  },
  {
    name: 'Guam',
    iso2Code: 'GU',
  },
  {
    name: 'Hawaii',
    iso2Code: 'HI',
  },
  {
    name: 'Idaho',
    iso2Code: 'ID',
  },
  {
    name: 'Illinois',
    iso2Code: 'IL',
  },
  {
    name: 'Indiana',
    iso2Code: 'IN',
  },
  {
    name: 'Iowa',
    iso2Code: 'IA',
  },
  {
    name: 'Kansas',
    iso2Code: 'KS',
  },
  {
    name: 'Kentucky',
    iso2Code: 'KY',
  },
  {
    name: 'Louisiana',
    iso2Code: 'LA',
  },
  {
    name: 'Maine',
    iso2Code: 'ME',
  },
  {
    name: 'Maryland',
    iso2Code: 'MD',
  },
  {
    name: 'Massachusetts',
    iso2Code: 'MA',
  },
  {
    name: 'Michigan',
    iso2Code: 'MI',
  },
  {
    name: 'Minnesota',
    iso2Code: 'MN',
  },
  {
    name: 'Mississippi',
    iso2Code: 'MS',
  },
  {
    name: 'Missouri',
    iso2Code: 'MO',
  },
  {
    name: 'Montana',
    iso2Code: 'MT',
  },
  {
    name: 'National',
    iso2Code: 'NA',
  },
  {
    name: 'Nebraska',
    iso2Code: 'NE',
  },
  {
    name: 'Nevada',
    iso2Code: 'NV',
  },
  {
    name: 'New Hampshire',
    iso2Code: 'NH',
  },
  {
    name: 'New Jersey',
    iso2Code: 'NJ',
  },
  {
    name: 'New Mexico',
    iso2Code: 'NM',
  },
  {
    name: 'New York',
    iso2Code: 'NY',
  },
  {
    name: 'North Carolina',
    iso2Code: 'NC',
  },
  {
    name: 'North Dakota',
    iso2Code: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    iso2Code: 'MP',
  },
  {
    name: 'Ohio',
    iso2Code: 'OH',
  },
  {
    name: 'Oklahoma',
    iso2Code: 'OK',
  },
  {
    name: 'Oregon',
    iso2Code: 'OR',
  },
  {
    name: 'Pennsylvania',
    iso2Code: 'PA',
  },
  {
    name: 'Puerto Rico',
    iso2Code: 'PR',
  },
  {
    name: 'Rhode Island',
    iso2Code: 'RI',
  },
  {
    name: 'South Carolina',
    iso2Code: 'SC',
  },
  {
    name: 'South Dakota',
    iso2Code: 'SD',
  },
  {
    name: 'Tennessee',
    iso2Code: 'TN',
  },
  {
    name: 'Texas',
    iso2Code: 'TX',
  },
  {
    name: 'Utah',
    iso2Code: 'UT',
  },
  {
    name: 'Vermont',
    iso2Code: 'VT',
  },
  {
    name: 'Virgin Islands',
    iso2Code: 'VI',
  },
  {
    name: 'Virginia',
    iso2Code: 'VA',
  },
  {
    name: 'Washington',
    iso2Code: 'WA',
  },
  {
    name: 'West Virginia',
    iso2Code: 'WV',
  },
  {
    name: 'Wisconsin',
    iso2Code: 'WI',
  },
  {
    name: 'Wyoming',
    iso2Code: 'WY',
  },
];
